export const getOrderKey = (clientId: string) => `Trac.Order.${clientId}`;